module.exports = __webpack_public_path__ + "img/hotel-14.4c3d9826.jpeg";